import React, { useEffect, useState } from "react";
import { ToggleButtonGroup } from "@mui/material";
import { Filter } from "../../../../context/ConfigContext/types";
import MuiToggleButton from "@mui/material/ToggleButton";
import { styled } from "@mui/material/styles";
import { grayMed, grayscaleBg, grayscaleText } from "../../../../styles/theme";
import { useConfig } from "../../../../context/ConfigContext";

interface GenericToggleButtonProps {
  filter: Filter;
}

type ToggleValue = "yes" | "no";

const ToggleButton = styled(MuiToggleButton)({
  backgroundColor: grayMed,
  color: grayscaleText,
  textTransform: "none",
  fontSize: "18px",
  padding: "8px 16px 10px 15px",
  height: "40px",
  border: "none",
  borderRadius: " 4px !important",
  "&.Mui-selected, &.Mui-selected:hover, &:hover": {
    backgroundColor: grayscaleBg,
    color: grayscaleText,
  },
});

const CheckedToggle: React.FunctionComponent<GenericToggleButtonProps> = ({ filter }) => {
  const { toggleFilterChecked } = useConfig();
  const [alignment, setAlignment] = useState<ToggleValue | null>(null);

  useEffect(() => {
    const checkedItem = filter.filterItems.find((item) => item.checked);
    setAlignment(checkedItem ? (checkedItem.value as ToggleValue) : null);
  }, [filter.filterItems]);

  const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: ToggleValue) => {
    const uncheckAll = newValue ? false : true;
    toggleFilterChecked(filter.filterName, newValue, uncheckAll);
  };

  return (
    <ToggleButtonGroup
      sx={{ display: "flex", gap: "10px" }}
      color="primary"
      value={alignment}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
    >
      {filter.filterItems.map((item) => (
        <ToggleButton key={item.filterLabel} value={item.value}>
          {item.filterLabel}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default CheckedToggle;
